import { Card, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../data";
import { getUserType } from "../../helpers/userDetails";
import DashboardReportsOverview from "./DashboardReportsOverview";
import "./index.css";

const DashboardComponent = () => {
  const navigate = useNavigate();
  const [routes, setRoutes] = useState<any>([]);
  const userType = getUserType();
  const showReportsOverview = userType === "CEO" || userType === "CASHIER";

  useEffect(() => {
    const routes = AppRoutes();
    const _items = routes.filter(
      (item: any) => item.show === true && item.path !== "/"
    );
    setRoutes(_items);
  }, []);

  return (
    <div className="dashboard-page-wrap">
      {showReportsOverview && <DashboardReportsOverview />}
      <div className="dashboard-links-section">
        <Typography.Title level={5} className="dashboard-links-heading">
          Quick links
        </Typography.Title>
        <Row gutter={[16, 16]}>
          {routes.map((item: any) => {
            return (
              <Col
                xs={24}
                sm={12}
                md={8}
                lg={6}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(item.path);
                }}
                key={item.path as string}
              >
                <Card className="dashboard-item-card">
                  <img src={item.activeIcon} alt="" />
                  <Typography className="dashboard-item-text">
                    {item.text}
                  </Typography>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};
export default DashboardComponent;
